'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const AttendanceTrendChart = dynamic(() => import('./AttendanceTrendChart'), { ssr: false });
const SportMembershipChart = dynamic(() => import('./SportMembershipChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-5 2xl:grid-cols-5 gap-6">
      <div className="xl:col-span-3 2xl:col-span-3">
        <AttendanceTrendChart />
      </div>
      <div className="xl:col-span-2 2xl:col-span-2">
        <SportMembershipChart />
      </div>
    </div>
  );
}